import { PlanCode } from './subscription'

export enum FeatureKey {
  MONTHLY_TOKENS = 'monthlyTokens',
  SHARED_PATIENTS = 'sharedPatients',
  MULTIPLE_SCRIPTS = 'multipleScripts',
  MULTIPLE_LOCATIONS = 'multipleLocations',
}

export type PlanEntitlements = {
  [FeatureKey.MONTHLY_TOKENS]: number
  [FeatureKey.SHARED_PATIENTS]: boolean
  [FeatureKey.MULTIPLE_SCRIPTS]: boolean
  [FeatureKey.MULTIPLE_LOCATIONS]: boolean
}

export interface CurrentOrganizationEntitlements {
  organizationId: string
  planCode: PlanCode | null
  entitlements: PlanEntitlements
}
